import React, { Component } from 'react';

// The intro splash on the Configure step (issue #71). A small message
// bar expands and collapses a single lead paragraph introducing the
// configurator; route selection lives on the License Key step, so the
// splash carries no buttons. The search bar and property list stay put
// either way, so toggling it does not reflow the page.
export class ConfigureSplash extends Component {
    displayName = ConfigureSplash.name;

    render() {
        const collapsed = this.props.collapsed;

        return (
            <div className={`c-splash ${collapsed ?
                'c-splash--collapsed' : 'c-splash--expanded'}`}>
                <button type="button" className="c-splash__bar"
                    aria-expanded={!collapsed}
                    onClick={this.props.onToggleSplash}>
                    <span className="c-splash__bar-text">
                        {collapsed
                            ? 'Select your properties before adding details ' +
                              'to generate your resource key'
                            : 'Build your own real-time data configuration'}
                    </span>
                    <span className={`c-splash__chevron ${collapsed ?
                        '' : 'c-splash__chevron--open'}`} aria-hidden="true" />
                </button>

                {collapsed ? null : (
                    <div className="c-splash__inner">
                        <p className="c-splash__lead">
                            Select your Device and IP Intelligence
                            properties.
                        </p>
                        <p className="c-splash__sublead">
                            A License Key will be required to generate a
                            Resource Key for use within the 51Degrees Cloud
                            Service. There are free and paid property
                            options, for more information go to our{' '}
                            <a href="https://51degrees.com/pricing"
                                target="_blank"
                                rel="noopener noreferrer">
                                pricing page</a>.
                        </p>
                        <p className="g-info__description">
                            Using an AI assistant? It can do these steps
                            for you through our MCP server at{' '}
                            <a href="https://51degrees.com/documentation/_services__configurator.html#Creating_a_Resource_Key_with_an_AI_agent"
                                target="_blank" rel="noopener noreferrer"
                                className="b-link">
                                configure.51degrees.com/mcp
                            </a>.
                        </p>
                    </div>
                )}
            </div>
        );
    }
}
